/**
 * Dynamically determine the API URL based on the current hostname
 * This allows the app to work both locally and when accessed remotely
 */
export const getApiUrl = () => {
  // If REACT_APP_API_URL is explicitly set, use it
  if (process.env.REACT_APP_API_URL) {
    const apiUrl = process.env.REACT_APP_API_URL;
    // Debug log to verify env var is being used
    if (typeof window !== 'undefined' && window.location) {
      if (process.env.NODE_ENV !== 'production') console.log('[API] Using REACT_APP_API_URL:', apiUrl);
    }
    return apiUrl;
  }

  // Safety check: window.location is not available during webpack compilation
  if (typeof window === 'undefined' || !window.location) {
    // During webpack compilation, return a default
    // This will be recomputed at runtime in the browser
    return 'http://localhost:8002'; // Default fallback
  }

  // Check if running in Capacitor (iOS/Android native app)
  const isCapacitor = window.location.protocol === 'capacitor:' ||
                      (window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform());

  if (isCapacitor) {
    // Capacitor app - always use production API
    const apiUrl = 'https://app.runium.ai/api';
    if (process.env.NODE_ENV !== 'production') console.log('[API] Capacitor detected, using production API:', apiUrl);
    return apiUrl;
  }

  // Otherwise, determine based on current hostname (runtime only)
  const hostname = window.location.hostname;
  let apiUrl;

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    // Local development - use direct port
    apiUrl = 'http://localhost:8002';
  } else if (hostname === 'app.runium.ai') {
    // Production - use nginx /api proxy (same origin)
    apiUrl = '/api';
  } else {
    // Other remote hosts (like EC2 IP) - use port 9000
    apiUrl = `http://${hostname}:9000`;
  }

  // Debug log for dynamic URL
  if (process.env.NODE_ENV !== 'production') console.log('[API] Using dynamic API URL:', apiUrl, 'from hostname:', hostname);
  return apiUrl;
};

// IMPORTANT: Do NOT call getApiUrl() at module load time!
// window.location is not available during webpack compilation (Node.js environment)
// This would cause webpack to hang or fail.

// Export a function that recomputes at runtime to ensure we get the correct URL
// This is especially important for mobile where the hostname might differ
// NOTE: We don't export API_URL as a constant anymore - always use getApiUrl() at runtime
